export default __webpack_public_path__ + "static/media/aws.58695f4f.webp";